import { StoreAction } from '@shared/store/store-action.model';
import { StoreActionError } from '@shared/store/store-action-error.model';

import {
  NotificationsReadUpdateApiPayload,
} from '../models/notifications-read-update-api.model';
import {
  NotificationsUnreadUpdateApiPayload,
} from '../models/notifications-unread-update-api.model';

const NOTIFICATIONS_SCOPE = '[Notifications]';
const API_SCOPE = `${ NOTIFICATIONS_SCOPE } API`;

export namespace NotificationsActions {

  export class Get extends StoreAction {
    static override readonly type = `${ API_SCOPE } Get`;
  }

  export class GetSuccess extends StoreAction {
    static override readonly type = `${ API_SCOPE } Get Success`;
  }

  export class GetFailed extends StoreActionError {
    static override readonly type = `${ API_SCOPE } Get Failed`;
  }

  export class GetRead extends StoreAction {
    static override readonly type = `${ API_SCOPE } Get Read`;
  }

  export class GetReadFailed extends StoreActionError {
    static override readonly type = `${ API_SCOPE } Get Read Failed`;
  }

  export class GetUnread extends StoreAction {
    static override readonly type = `${ API_SCOPE } Get Unread`;
  }

  export class GetUnreadFailed extends StoreActionError {
    static override readonly type = `${ API_SCOPE } Get Unread Failed`;
  }

  export class GetById extends StoreAction<string> {
    static override readonly type = `${ API_SCOPE } Get By Id`;

    constructor(public override payload: string) {
      super(payload);
    }
  }

  export class GetByIdFailed extends StoreActionError {
    static override readonly type = `${ API_SCOPE } Get By Id Failed`;
  }

  export class MarkRead extends StoreAction<NotificationsReadUpdateApiPayload> {
    static override readonly type = `${ API_SCOPE } Mark Read`;
  }

  export class MarkReadFailed extends StoreActionError {
    static override readonly type = `${ API_SCOPE } Mark Read Failed`;
  }

  export class MarkUnread extends StoreAction<NotificationsUnreadUpdateApiPayload> {
    static override readonly type = `${ API_SCOPE } Mark Unread`;
  }

  export class MarkUnreadFailed extends StoreActionError {
    static override readonly type = `${ API_SCOPE } Mark Unread Failed`;
  }

  export class Select extends StoreAction<string> {
    static override readonly type = `${ NOTIFICATIONS_SCOPE } Select`;

    constructor(public override payload: string) {
      super(payload);
    }
  }

  export class ResetLoadedState extends StoreAction {
    static override readonly type = `${ NOTIFICATIONS_SCOPE } Reset Loaded State`;
  }

  export class ResetState extends StoreAction {
    static override readonly type = `${ NOTIFICATIONS_SCOPE } Reset State`;
  }
}
